const initialState = {
  deposits: { data: [] },
};

export const deposit_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DEPOSITS":
      return {
        ...state,
        deposits: action.payload,
      };
    case "DELETE_DEPOSIT":
      return {
        ...state,
        deposits: {
          ...state.deposits,
          data: state.deposits.data.filter((li) => li.id !== action.payload),
        },
      };
    default:
      return state;
  }
};
